module.exports = __webpack_public_path__ + "img/ava.00cfdfd7.png";